import { render, staticRenderFns } from "./dialogAddress.vue?vue&type=template&id=0a0e92fa&"
import script from "./dialogAddress.vue?vue&type=script&lang=js&"
export * from "./dialogAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports